/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import type { AuthnContextUpdateChallenge } from './AuthnContextUpdateChallenge';
import {
    instanceOfAuthnContextUpdateChallenge,
    AuthnContextUpdateChallengeFromJSON,
    AuthnContextUpdateChallengeFromJSONTyped,
    AuthnContextUpdateChallengeToJSON,
} from './AuthnContextUpdateChallenge';
import type { NonceChallenge } from './NonceChallenge';
import {
    instanceOfNonceChallenge,
    NonceChallengeFromJSON,
    NonceChallengeFromJSONTyped,
    NonceChallengeToJSON,
} from './NonceChallenge';
import type { OIDCChallenge } from './OIDCChallenge';
import {
    instanceOfOIDCChallenge,
    OIDCChallengeFromJSON,
    OIDCChallengeFromJSONTyped,
    OIDCChallengeToJSON,
} from './OIDCChallenge';
import type { OTPChallenge } from './OTPChallenge';
import {
    instanceOfOTPChallenge,
    OTPChallengeFromJSON,
    OTPChallengeFromJSONTyped,
    OTPChallengeToJSON,
} from './OTPChallenge';
import type { PasswordResetChallenge } from './PasswordResetChallenge';
import {
    instanceOfPasswordResetChallenge,
    PasswordResetChallengeFromJSON,
    PasswordResetChallengeFromJSONTyped,
    PasswordResetChallengeToJSON,
} from './PasswordResetChallenge';
import type { PasswordSetChallenge } from './PasswordSetChallenge';
import {
    instanceOfPasswordSetChallenge,
    PasswordSetChallengeFromJSON,
    PasswordSetChallengeFromJSONTyped,
    PasswordSetChallengeToJSON,
} from './PasswordSetChallenge';
import type { PasswordVerifyChallenge } from './PasswordVerifyChallenge';
import {
    instanceOfPasswordVerifyChallenge,
    PasswordVerifyChallengeFromJSON,
    PasswordVerifyChallengeFromJSONTyped,
    PasswordVerifyChallengeToJSON,
} from './PasswordVerifyChallenge';
import type { ProxyChallenge } from './ProxyChallenge';
import {
    instanceOfProxyChallenge,
    ProxyChallengeFromJSON,
    ProxyChallengeFromJSONTyped,
    ProxyChallengeToJSON,
} from './ProxyChallenge';
import type { SAMLChallenge } from './SAMLChallenge';
import {
    instanceOfSAMLChallenge,
    SAMLChallengeFromJSON,
    SAMLChallengeFromJSONTyped,
    SAMLChallengeToJSON,
} from './SAMLChallenge';
import type { TOTPRegisterChallenge } from './TOTPRegisterChallenge';
import {
    instanceOfTOTPRegisterChallenge,
    TOTPRegisterChallengeFromJSON,
    TOTPRegisterChallengeFromJSONTyped,
    TOTPRegisterChallengeToJSON,
} from './TOTPRegisterChallenge';
import type { TOTPVerifyChallenge } from './TOTPVerifyChallenge';
import {
    instanceOfTOTPVerifyChallenge,
    TOTPVerifyChallengeFromJSON,
    TOTPVerifyChallengeFromJSONTyped,
    TOTPVerifyChallengeToJSON,
} from './TOTPVerifyChallenge';
import type { UICustomizationChallenge } from './UICustomizationChallenge';
import {
    instanceOfUICustomizationChallenge,
    UICustomizationChallengeFromJSON,
    UICustomizationChallengeFromJSONTyped,
    UICustomizationChallengeToJSON,
} from './UICustomizationChallenge';
import type { WebAuthnCreateChallenge } from './WebAuthnCreateChallenge';
import {
    instanceOfWebAuthnCreateChallenge,
    WebAuthnCreateChallengeFromJSON,
    WebAuthnCreateChallengeFromJSONTyped,
    WebAuthnCreateChallengeToJSON,
} from './WebAuthnCreateChallenge';
import type { WebAuthnGetChallenge } from './WebAuthnGetChallenge';
import {
    instanceOfWebAuthnGetChallenge,
    WebAuthnGetChallengeFromJSON,
    WebAuthnGetChallengeFromJSONTyped,
    WebAuthnGetChallengeToJSON,
} from './WebAuthnGetChallenge';

/**
 * @type ChallengeListInner
 * 
 * @export
 */
export type ChallengeListInner = { type: 'authn_context_update' } & AuthnContextUpdateChallenge | { type: 'nonce' } & NonceChallenge | { type: 'oidc' } & OIDCChallenge | { type: 'otp' } & OTPChallenge | { type: 'password_reset' } & PasswordResetChallenge | { type: 'password_set' } & PasswordSetChallenge | { type: 'password_verify' } & PasswordVerifyChallenge | { type: 'proxy' } & ProxyChallenge | { type: 'saml' } & SAMLChallenge | { type: 'totp_register' } & TOTPRegisterChallenge | { type: 'totp_verify' } & TOTPVerifyChallenge | { type: 'ui_customization' } & UICustomizationChallenge | { type: 'webauthn_create' } & WebAuthnCreateChallenge | { type: 'webauthn_get' } & WebAuthnGetChallenge;

export function ChallengeListInnerFromJSON(json: any): ChallengeListInner {
    return ChallengeListInnerFromJSONTyped(json, false);
}

export function ChallengeListInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChallengeListInner {
    if (json == null) {
        return json;
    }
    switch (json['type']) {
        case 'authn_context_update':
            return Object.assign({}, AuthnContextUpdateChallengeFromJSONTyped(json, true), { type: 'authn_context_update' } as const);
        case 'nonce':
            return Object.assign({}, NonceChallengeFromJSONTyped(json, true), { type: 'nonce' } as const);
        case 'oidc':
            return Object.assign({}, OIDCChallengeFromJSONTyped(json, true), { type: 'oidc' } as const);
        case 'otp':
            return Object.assign({}, OTPChallengeFromJSONTyped(json, true), { type: 'otp' } as const);
        case 'password_reset':
            return Object.assign({}, PasswordResetChallengeFromJSONTyped(json, true), { type: 'password_reset' } as const);
        case 'password_set':
            return Object.assign({}, PasswordSetChallengeFromJSONTyped(json, true), { type: 'password_set' } as const);
        case 'password_verify':
            return Object.assign({}, PasswordVerifyChallengeFromJSONTyped(json, true), { type: 'password_verify' } as const);
        case 'proxy':
            return Object.assign({}, ProxyChallengeFromJSONTyped(json, true), { type: 'proxy' } as const);
        case 'saml':
            return Object.assign({}, SAMLChallengeFromJSONTyped(json, true), { type: 'saml' } as const);
        case 'totp_register':
            return Object.assign({}, TOTPRegisterChallengeFromJSONTyped(json, true), { type: 'totp_register' } as const);
        case 'totp_verify':
            return Object.assign({}, TOTPVerifyChallengeFromJSONTyped(json, true), { type: 'totp_verify' } as const);
        case 'ui_customization':
            return Object.assign({}, UICustomizationChallengeFromJSONTyped(json, true), { type: 'ui_customization' } as const);
        case 'webauthn_create':
            return Object.assign({}, WebAuthnCreateChallengeFromJSONTyped(json, true), { type: 'webauthn_create' } as const);
        case 'webauthn_get':
            return Object.assign({}, WebAuthnGetChallengeFromJSONTyped(json, true), { type: 'webauthn_get' } as const);
        default:
            return json;
    }
}

export function ChallengeListInnerToJSON(json: any): any {
    return ChallengeListInnerToJSONTyped(json, false);
}

export function ChallengeListInnerToJSONTyped(value?: ChallengeListInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    switch (value['type']) {
        case 'authn_context_update':
            return Object.assign({}, AuthnContextUpdateChallengeToJSON(value), { type: 'authn_context_update' } as const);
        case 'nonce':
            return Object.assign({}, NonceChallengeToJSON(value), { type: 'nonce' } as const);
        case 'oidc':
            return Object.assign({}, OIDCChallengeToJSON(value), { type: 'oidc' } as const);
        case 'otp':
            return Object.assign({}, OTPChallengeToJSON(value), { type: 'otp' } as const);
        case 'password_reset':
            return Object.assign({}, PasswordResetChallengeToJSON(value), { type: 'password_reset' } as const);
        case 'password_set':
            return Object.assign({}, PasswordSetChallengeToJSON(value), { type: 'password_set' } as const);
        case 'password_verify':
            return Object.assign({}, PasswordVerifyChallengeToJSON(value), { type: 'password_verify' } as const);
        case 'proxy':
            return Object.assign({}, ProxyChallengeToJSON(value), { type: 'proxy' } as const);
        case 'saml':
            return Object.assign({}, SAMLChallengeToJSON(value), { type: 'saml' } as const);
        case 'totp_register':
            return Object.assign({}, TOTPRegisterChallengeToJSON(value), { type: 'totp_register' } as const);
        case 'totp_verify':
            return Object.assign({}, TOTPVerifyChallengeToJSON(value), { type: 'totp_verify' } as const);
        case 'ui_customization':
            return Object.assign({}, UICustomizationChallengeToJSON(value), { type: 'ui_customization' } as const);
        case 'webauthn_create':
            return Object.assign({}, WebAuthnCreateChallengeToJSON(value), { type: 'webauthn_create' } as const);
        case 'webauthn_get':
            return Object.assign({}, WebAuthnGetChallengeToJSON(value), { type: 'webauthn_get' } as const);
        default:
            return value;
    }
}

